const constants = {
  HOME: {
    HOME_CONTAINERS: 'homeContainers',
    HOME_RESIDENTIAL_SECTION: 'homeResidentialSection',
    HOME_COMMERCIAL_SECTION: 'homeCommercialSection',
    HOME_PROMO: 'goPropane',
    HOME_RESIDENTIAL_CUSTOMERS: 'clientSpaceContentList',
    HOME_REFERRAL_PROGRAM: 'homeReferralProgram',
    HOME_CARDS: 'cards',
    HOME_DELIVERY_PRODUCTS: 'imageWithLinkList',
    HOME_MAP_CONTAINER: 'homeMapContainer',
    HOME_CUSTOMER_CARE: 'customerCareMultipleImages',
    HOME_HSC_SECTION: 'headerTextLinkText',
    HOME_PLEDGE_PROGRAM: 'homePledgeProgram',
    HOME_TRACK_YOUR_DELIVERY: 'trackYourDelivery',
  },
  COMMON: {
    FOOTER: 'footer',
    NAVIGATION: 'navigation',
    EBILLING_POP_UP: {
      DEFAULT: 'contactCustomerCareeBillingContents',
      FOR_HOME: 'contactCustomerCareEBillingForHome',
      FOR_BUSINESS: 'contactCustomerCareEBillingForYourBusiness',
      BACKGROUND_IMAGE: 'ebillingPopupBackground',
    },
    OPEN_ACCOUNT_POP_UP: {
      DEFAULT: 'contactCustomerCareOpenAnAccountContents',
      FOR_HOME: 'contactCustomerCareOpenAnAccoutPopUpForHome',
      FOR_BUSINESS: 'contactCustomerCareOpenAnAccountBusiness',
      BACKGROUND_IMAGE: 'openAnAccountPopupBackground',
    },
    PROPANE_POP_UP: {
      DEFAULT: 'propaneBackgroudImage',
      IMAGE: 'propanePopUpImage',
      FOR_HOME: 'propaneBackgroudImageForHome',
      FOR_BUSINESS: 'propaneBackgroudImageForbusiness',
      FOOTER: 'footerProductPropane',
      DELIVERING_MORE: 'homePropane',
      BACKGROUND_IMAGE: 'propanePopupBackground',
    },
  },
  DEFAULT_MENU: {
    REQUEST_A_CALLBACK: 'REQUEST A CALLBACK',
    SEARCH_SITE: 'SEARCH SITE',
    CLIENT_SPACE: {
      DEFAULT: 'CLIENT SPACE',
      CONTENT_LIST: 'clientSpaceContents',
      CONTENT: 'ClientSpaceContent',
      RESIDENTIAL_CONTENT: 'clientSpaceResidentialCustomer',
      COMMERCIAL_CONTENT: 'clientSpaceCommercialCustomers',
      CONTENT_TEXT_WITH_LINK: 'ClientSpaceContentLink',
    },
  },
  LOCATION_BLUEWAVE: {
    LOCATION_DETAILS_CONTENT: {
      PRODUCT_SUPPLIER: 'productSupplierInCityContent',
      PRODUCT_SUPPLIER_IMAGES: 'locationAddressProductSupplierImages',
      ALSO_AVAILABLE: 'locationDetailsAlsoAvailable',
      DIESEL_IMAGE: 'homeDiesel',
      HEATING_OIL_IMAGE: 'homeHeatingOil',
      LUBRICANTS_IMAGE: 'homeLubricants',
      PROPANE_IMAGE: 'homePropane',
      DEF_IMAGE: 'productDef',
    },
  },
  ABOUT_BLUEWAVE: {
    ABOUT_BLUEWAVE_SLUG: 'about',
    ABOUT_BLUEWAVE_TITLE: 'about island',
    ABOUT_NAVIGATION: 'about',
    HEALTH_AND_SAFETY: {
      SLUG: 'hse',
      TITLE: 'Health, Safety & Environment',
    },
  },
  THANKYOU_BLUEWAVE: {
    THANKYOU: {
      DEFAULT: 'ThankYou',
      HEADER_TEXT: 'residentialThankYouHeader',
      CONTENT: 'residentialThankYouContent',
    },
    RESIDENTIAL_EBILLING: {
      DEFAULT: 'residentialeBillingThankYou',
      HEADER_TEXT: 'residentialeBillingThankYouHeader',
      CONTENT_LIST: 'residentialThankYouContents',
      CONTENT: 'residentialThankYouContent ',
      TWITTER_LINK: 'residentialThankYouTwitterConnectLink',
    },
    COMMERCIAL_EBILLING: {
      DEFAULT: 'commercialThankYou',
      HEADER_TEXT: 'commercialThankYouHeader',
      CONTENT_LIST: 'commercialThankYouContents',
      CONTENT: 'commercialThankYouContent',
      TWITTER_LINK: 'comercialThankYouTwitterLink',
    },
    WELCOME: {
      DEFAULT: '',
      CONTENT: 'thankYouWelcomeContent',
    },
  },
  CONTACT_US: {
    CONTACT_NAVIGATION: 'contact',
  },
  PAGES: {
    PROPANE_YOU_TRUST: {
      DEFAULT: 'propaneYouCanTrust',
      TOP_BAR: 'propaneYouCanTrustHeader',
      IMAGE_CONTAINER: 'propaneYouCanTrustBackgroundImage',
      HEADER: 'propaneProviderHeader',
      CONTENT_LIST: {
        DEFAULT: 'propaneYouCanTrustContents',
        PROPANE_CONTACT_US: 'propaneContactUs',
        PROPANE_SERVICE_AREAS: 'propaneServiceAreas',
      },
    },
  },
};

export const LocationTypes = {
  Branch: 'Branch',
  Cardlock: 'Cardlock',
  Payment: 'Payment',
};

export const MenuType = [
  {
    path: 'about',
    name: 'about island'
  }
]

// Add logic to map new top-level slugs back to their intended parent context
export const PageContextMap = {
  'equipment': 'residential',
};

export const getPageTypeFromPath = (pathname) => {
  const segments = pathname?.split('/').filter(n => n);
  if (!segments || segments.length === 0) {
    return null; // Or a safe default if home page logic needs it
  }
  const topSegment = segments[0];
  // Check the map first, otherwise return the segment itself
  return PageContextMap[topSegment] || topSegment;
}

export default constants;

